/**
 * Registers `dist/sw.js`, built and named by the `pwaShell` plugin in
 * `vite.config.ts`. Production only: `npm run dev` has no `dist/`, and a
 * service worker caching the Vite dev server's own responses is a stale
 * bundle away from a debugging session about the wrong problem.
 *
 * A browser with no `serviceWorker` in `navigator` — an old one, or a
 * `<webview>` — gets the ordinary online app and nothing else; there is
 * nothing to detect and branch on beyond the one `if` below, because
 * everything the worker does (the offline shell, the write queue) is already
 * optional from the app's own point of view.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return
  if (!('serviceWorker' in navigator)) return

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err: unknown) => {
      console.error('service worker registration failed', err)
    })
  })
}
